import {Injectable} from '@angular/core';
import {errorMessages} from './errorMessages';
import {HttpErrorResponse} from '@angular/common/http';
import {DataServiceError} from '@ngrx/data';
import {underscore} from '@angular-devkit/core/src/utils/strings';

@Injectable({ providedIn: 'root' })
export class ErrorMessageResolver {

    public resolveKey(error: any) {
        if (typeof error === 'string'){
            return error;
        }

        if (error instanceof HttpErrorResponse) {
            return this.getHttpErrorMessageKey(error);
        }
        if (error instanceof DataServiceError) {
            return this.getDataServiceErrorMessageKey(error);
        }
        const actionError = error?.payload?.data?.error;
        if (actionError && actionError instanceof DataServiceError) {
            return this.getDataServiceErrorMessageKey(actionError);
        }
        return undefined;
    }

    public resolveError(error: any){
        const key = this.resolveKey(error);
        let message;
        if (key) {
            message = this.resolve(key);
        }
        // console.log(['key', key, message]);
        return message ? message : this.defaultMessage;
    }

    public resolveOrGetDefault(key: string) {
        let value = this.resolve(key);
        if (!value){
            value = this.defaultMessage;
        }
        return value;
    }

    public resolve(key: string): string {
        return errorMessages.get(key);
    }

    public get defaultMessage(): string {
        return this.resolve('default');
    }

    private getDataServiceErrorMessageKey(dataServiceError: DataServiceError): string {
        if (dataServiceError.error instanceof HttpErrorResponse) {
            return this.getHttpErrorMessageKey(dataServiceError.error);
        }
        return undefined;
    }

    private getHttpErrorMessageKey(httpErrorResponse: HttpErrorResponse): string {
        if (httpErrorResponse.error.error === 'Not found') {
            return '404';
        }
        if (httpErrorResponse.status === 400){
            return httpErrorResponse.error.message;
        }
        if (httpErrorResponse.status === 403) {
            return '403';
        }
        return undefined;
    }
}
